import {FC} from "react";
import {useDispatch} from "react-redux";
import {Link} from "react-router-dom";

import clsx from "clsx";

import {reducerSidebar} from "../../../redux/reducer/user/reducers/reducerUser";
import {AppDispatch} from "../../../redux/reducer/store";

import SidebarLink from "../../custom/sidebarLink/sidebarLink";

import {ReactComponent as VisitGraphIcon} from "../../../assets/icons/visit-graph-icon.svg";
import {ReactComponent as ReportsIcon} from "../../../assets/icons/reports-icon.svg";
import {ReactComponent as UnloadingsIcon} from "../../../assets/icons/unloading.svg";
import {ReactComponent as ChevronIcon} from "../../../assets/icons/chevron.svg";
import {ReactComponent as VacancyIcon} from '../../../assets/icons/vacancy.svg';
import {ReactComponent as ListIcon} from "../../../assets/icons/list-icon.svg";
import {ISettingCustomer} from "../../../types/interfaces";

interface ICustomerSidebarOptions {
    isOpenUnloadings: boolean;
    isOpenSidebar: boolean;
    data: {
        email: string;
        id: number;
        isAdmin: boolean;
        isCustomer: boolean;
        login: string;
        role: { [key: string]: string }
        settings: ISettingCustomer;
        token: string;
        type: string;
    };
}

const additionalLinks = [
    {to: "/unloadings/excel", text: "Excel"},
    {to: "/unloadings/zip", text: "Zip"},
];

const CustomerSidebarSection: FC<ICustomerSidebarOptions> = ({
                                                                 isOpenUnloadings,
                                                                 isOpenSidebar,
                                                                 data,
                                                             }) => {
    const dispatch = useDispatch<AppDispatch>();

    const pathname = window.location.pathname;

    const handleOpenUnloadings = (event: React.MouseEvent) => {
        event.preventDefault();
        localStorage.setItem("isOpenUnloadings", JSON.stringify(!isOpenUnloadings));

        dispatch(
            reducerSidebar({
                               isOpenSidebar: isOpenSidebar,
                               isOpenUnloadings: !isOpenUnloadings,
                           })
        );
    };

    return (
        <div className="menu__item">
            <div className="buttons">
                {data.settings.analytics && (
                    <SidebarLink
                        icon={<VacancyIcon className='default__sidebar_icon active__sidebar_icon'/>}
                        to={'/charts'}
                        content='Аналитика'
                    />
                )}
                <SidebarLink
                    icon={<ReportsIcon className="default__sidebar_icon active__sidebar_icon"/>}
                    content="Отчеты"
                    to="/reports"
                />
                <SidebarLink
                    chevron={
                        <ChevronIcon
                            className={clsx(
                                "chevron__icon",
                                isOpenUnloadings && "active__chevron_icon",
                                "active__sidebar_icon"
                            )}
                            onClick={handleOpenUnloadings}
                        />
                    }
                    icon={<UnloadingsIcon className="default__sidebar_icon active__sidebar_icon"/>}
                    to="/unloadings/excel"
                    content="Выгрузки"
                />
                <div
                    className={clsx(
                        "additional__links_block",
                        isOpenUnloadings && "active__additional_links"
                    )}
                >
                    {additionalLinks.map((link) => (
                        <span
                            className={clsx(
                                "additional__link",
                                isOpenUnloadings && "active__additional_link"
                            )}
                            key={link.to}
                        >
              <Link
                  className={clsx(
                      "link",
                      pathname.includes(link.to) && "underline"
                  )}
                  to={link.to}
              >
                {link.text}
              </Link>
            </span>
                    ))}
                </div>
                {data?.settings?.visitSchedule && (
                    <SidebarLink
                        icon={<VisitGraphIcon className="default__sidebar_icon active__sidebar_icon"/>}
                        to="/visit-schedule"
                        content="График"
                    />
                )}
                {data?.settings?.posMap &&
                 <SidebarLink
                     icon={<ReportsIcon className="default__sidebar_icon active__sidebar_icon"/>}
                     content="Карта обслуживания"
                     to="/map"
                 />
                }
                {data?.settings?.showContractInfo &&
                 <SidebarLink
                     icon={<ListIcon className="default__sidebar_icon active__sidebar_icon"/>}
                     content="Контракты"
                     to="/contracts"
                 />
                }
            </div>
        </div>
    );
};

export default CustomerSidebarSection;
